import * as ActionTypes from './actions';
import * as AuthActionTypes from '../../auth/actions';
import update from 'immutability-helper';

const initialState = {
	loading: false,
	canConfigureSystemAlerts: false,
	systemAlertEvents: ''	// comma separated list of event types
};

const profile = (state = initialState, action) => {
	switch (action.type) {
		case AuthActionTypes.LOGOUT:
			return initialState;
		case ActionTypes.USER_SETTINGS_FETCH_REQUEST:
		case ActionTypes.USER_SETTINGS_UPDATE_REQUEST:
			return update(state, {
				loading: { $set: true }
			});
		case ActionTypes.USER_SETTINGS_FETCH_FAILURE:
		case ActionTypes.USER_SETTINGS_UPDATE_FAILURE:
			return update(state, {
				loading: { $set: false }
			});
		case ActionTypes.USER_SETTINGS_FETCH_SUCCESS:
		case ActionTypes.USER_SETTINGS_UPDATE_SUCCESS:
			return update(state, { $merge: { ...action.response, loading: false } });
		default:
			return state;
	}
};

export default profile;
